import React, { useState } from "react";
import { formatDate } from "../../services/helpers";

export interface Authorization {
  checked: boolean;
  dated: Date;
  aCity: string;
  aState: string;
  fullName: string;
}

interface AuthorizationProps {
  authText?: string;
  authorization: Authorization;
  validationErrors: { [key: string]: string };
  type?: string;
  isReadOnly?: boolean;
  isEditing?: boolean;
  onEditClick?: (text: string) => void;
  onInputChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    field: string,
    index?: number,
    type?: string,
  ) => void;
}

const AuthorizationForm: React.FC<AuthorizationProps> = ({
  authText,
  authorization,
  validationErrors,
  onInputChange,
  onEditClick,
  type,
  isReadOnly,
  isEditing,
}) => {
  const [isHovered, setIsHovered] = useState<string | null>(null);

  return (
    <div className="data-container" style={{ minWidth: "100%" }}>
      {authorization && (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "nowrap",
              flex: "0 0 100%",
            }}
          >
            <div className="field-input" style={{ flex: "0 0 3%" }}>
              <input
                className={`form-check-input ${
                  validationErrors[`checked${type}`] ? "is-invalid" : ""
                }`}
                type="checkbox"
                checked={authorization.checked}
                onChange={(e) => onInputChange(e, "checked", 0, type)}
                disabled={isReadOnly}
              />
            </div>

            {isEditing ? (
              <div
                className={`editable-text-container hover-enabled`}
                onMouseEnter={() =>
                  setIsHovered(
                    type === "referenceAuthorization"
                      ? "authorization"
                      : "statementOfApplicant",
                  )
                }
                onMouseLeave={() => setIsHovered(null)}
              >
                <div
                  className={`editable-text ${
                    isHovered === "statementOfApplicant" ||
                    isHovered === "authorization"
                      ? "blurred"
                      : ""
                  }`}
                >
                  {authText?.trim() ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: authText,
                      }}
                    />
                  ) : (
                    <span className="empty-placeholder">
                      [Click to add text]
                    </span>
                  )}
                </div>

                {(isHovered === "statementOfApplicant" ||
                  isHovered === "authorization") && (
                  <button
                    className="edit-icon"
                    onClick={() => {
                      if (onEditClick) {
                        onEditClick(authText || "");
                      }
                    }}
                  >
                    {authText?.trim() ? (
                      <i className="bi bi-pencil"></i>
                    ) : (
                      <i className="bi bi-plus"></i>
                    )}
                  </button>
                )}
              </div>
            ) : authText?.length === 0 ? (
              <label className="field-label" style={{ textWrap: "wrap" }}>
                I attest that the answers I have given are true to the best of
                my knowledge
              </label>
            ) : (
              <label className="field-label" style={{ textWrap: "wrap" }}>
                {authText?.split("\n").map((line, index) => (
                  <p key={index}>{line}</p>
                ))}
              </label>
            )}

            <div>
              {validationErrors[`checked${type}`] && (
                <div
                  className="invalid-feedback"
                  style={{ paddingLeft: "20px", display: "block" }}
                >
                  {validationErrors[`checked${type}`]}
                </div>
              )}
            </div>
          </div>

          <div className="field-stacked" style={{ flex: "0 0 20%" }}>
            <label className="field-label">Dated:</label>
            <div className="field-input">
              <input
                className={`form-control`}
                value={formatDate(authorization.dated)}
                disabled
              />
            </div>
          </div>
          {/* <div
            className="text-body"
            style={{
              display: "flex",
              alignItems: "end",
              paddingBottom: "10px",
            }}
          >
            at
          </div> */}
          {/* <div className="field-stacked" style={{ flex: "0 0 40%" }}>
            <label className="field-label">City:</label>
            <div className="field-input">
              <input
                className={`form-control ${
                  validationErrors.aCity ? "is-invalid" : ""
                }`}
                type="text"
                value={authorization?.aCity || ""}
                onChange={(e) => onInputChange(e, "aCity")}
              />
              {validationErrors.aCity && (
                <div className="invalid-feedback">{validationErrors.aCity}</div>
              )}
            </div>
          </div>
          <div className="field-stacked" style={{ flex: "0 0 20%" }}>
            <label className="field-label">State:</label>
            <div className="field-input">
              <select
                className={`form-select ${
                  validationErrors.aState ? "is-invalid" : ""
                }`}
                value={authorization?.aState || ""}
                onChange={(e) => onInputChange(e, "aState")}
              >
                <option value="">Select State</option>
                {states.map((state) => (
                  <option key={state.abbreviation} value={state.abbreviation}>
                    {state.name} ({state.abbreviation})
                  </option>
                ))}
              </select>
              {validationErrors.aState && (
                <div className="invalid-feedback">
                  {validationErrors.aState}
                </div>
              )}
            </div>
          </div> */}
          <div className="field-stacked" style={{ flex: "0 0 75%" }}>
            <label className="field-label">Type full name:</label>
            <div className="field-input">
              <input
                className={`form-control ${
                  validationErrors[`fullName${type}`] ? "is-invalid" : ""
                }`}
                type="text"
                value={authorization?.fullName || ""}
                onChange={(e) => onInputChange(e, "fullName", 0, type)}
                disabled={isReadOnly}
              />
              {validationErrors[`fullName${type}`] && (
                <div className="invalid-feedback">
                  {validationErrors[`fullName${type}`]}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AuthorizationForm;
